module.exports = __webpack_public_path__ + "img/logoBracesco.ba49bf7c.svg";